import { Injectable } from '@angular/core';
import { NotificationService } from './notification.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/internal/operators/catchError';

@Injectable({
  providedIn: 'root'
})
export class MentorshipService {
  apiEndpoint: any;
  apiChatAppEndpoint: any;
  socketEndpoint: any;

  constructor(private http: HttpClient, private ns: NotificationService) { 
        this.apiEndpoint = environment.APIEndpoint;
        this.apiChatAppEndpoint = environment.socket_EndPoint;
        this.socketEndpoint = environment.socket_EndPoint;
  }


  // get mentors profile info
  mentorProfileInfo(id:string): Observable<any> {
    let params = new HttpParams();
    params = params.append('mentor_id', id);
    return this.http.get<any>(this.apiEndpoint + '/mentorship/profile/info', { params }).pipe(catchError(this.handleError));
  }

    // get mentors profile courses
    mentorProfileCourse(id:string): Observable<any> {
      let params = new HttpParams();
      params = params.append('mentor_id', id);
      return this.http.get<any>(this.apiEndpoint + '/mentorship/profile/courses', { params }).pipe(catchError(this.handleError));
    }

    // get mentors profile projects
    mentorProfileProjects(id:string): Observable<any> {
      let params = new HttpParams();
      params = params.append('mentor_id', id);
      return this.http.get<any>(this.apiEndpoint + '/mentorship/profile/projects', { params }).pipe(catchError(this.handleError));
    }

    // get mentors profile Testimonials
    mentorProfileTestimonials(id:string, role: string = ''): Observable<any> {
      let params = new HttpParams();
      if(role == 'student') {
        params = params.append('student_id', id);
      }
      else {
        params = params.append('mentor_id', id);
      }
      return this.http.get<any>(this.apiEndpoint + '/mentorship/profile/reviews', { params }).pipe(catchError(this.handleError));
    }

    // get mentors profile sessions
    mentorProfileSessions(id:string, role: string = ''): Observable<any> {
      let params = new HttpParams();
      if(role == 'student') {
        params = params.append('student_id', id);
      }
      else {
        params = params.append('mentor_id', id);
      }
      return this.http.get<any>(this.apiEndpoint + '/mentorship/profile/sessions', { params }).pipe(catchError(this.handleError));
    }
    
    
  // get top rated mentors
    getTopRatedMentors(currentPage): Observable<any> {
      let params = new HttpParams();
      params = params.append('page', currentPage);
      return this.http.get<any>(this.apiEndpoint + '/mentorship/top_rated_mentors', { params }).pipe(catchError(this.handleError));
    }



     /**
   * To get time slots
   *
   * @param {string} mentor_id - to get avaiable slots.
   * @param {string} date - Date for result.
   * @returns {observable} List of slots on success or error.
   */
   // get top rated mentors
      getTimeSlots(mentor_id:string, date:string): Observable<any> {
        let params = new HttpParams();
        params = params.append('mentor_id', mentor_id);
        params = params.append('date', date);
        return this.http.get<any>(this.apiEndpoint + '/mentorship/slots', { params }).pipe(catchError(this.handleError));
      }


   // get top rated mentors
      getCourseList(): Observable<any> {
        return this.http.get<any>(this.apiEndpoint + '/mentor/courses').pipe(catchError(this.handleError));
      }


      /**
   * To get time slots
   *
   * @param {object} payloadBody - json payload.
   * @returns {observable} List of slots on success or error.
   */
   // get top rated mentors
      slotBooking(payloadBody:any): Observable<any> {
       let body = payloadBody;
        return this.http.post<any>(this.apiChatAppEndpoint + '/mentor/slot/booking', body).pipe(catchError(this.handleError));
      }

      /**
   * To save events
   *
   * @param {object} payloadBody - json payload.
   * @returns {observable} response on success or error.
   */
   // To save event webinar
       webinarApi(payloadBody:any): Observable<any> {
       let body = payloadBody;
        return this.http.post<any>(this.apiEndpoint + '/mentorship/webinar', body).pipe(catchError(this.handleError));
      }


        /**
   * To save events
   *
   * @param {object} payloadBody - json payload.
   * @returns {observable} response on success or error.
   */
   // To save event webinar
       webinarApiPatch(payloadBody:any): Observable<any> {
        console.log(payloadBody)
       let body = payloadBody;
        return this.http.patch<any>(this.apiEndpoint + '/mentorship/webinar', body).pipe(catchError(this.handleError));
      }



      /**
   * To save events
   *
   * @param {object} payloadBody - json payload.
   * @returns {observable} response on success or error.
   */
   // To save event webinar
       doubtSessionApi(payloadBody:any): Observable<any> {
       let body = payloadBody;
        return this.http.post<any>(this.apiEndpoint + '/mentor/session', body).pipe(catchError(this.handleError));
      }


      handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        return throwError(error);
      }

  /**
   * To get searched mentors list
   *
   * @param {string} search - The search keyword.
   * @param {number} page - The page number.
   * @returns {observable} List for mentors on success or error.
   */
  searchMentors(search = '', page = ''): Observable<any> {
    let params = new HttpParams();

    if (search) {
      params = params.append('query', search);
    }

    if (page) {
      params = params.append('page', page);
    }

    return this.http.get<any>(this.apiEndpoint + '/mentorship/search_mentors', { params });
  }

  /**
   * To create chat room id to inititate chate with mentor
   * @param {object} postData - To get mentor data
   * @return {observable} - Chat room id on success or error.
   */
  createChatRoom(postData): Observable<any> {
    return this.http.post<any>(this.socketEndpoint + '/mentor/create_room', postData);
  }

  /**
   * To get mentor session details
   * @param {string} id - To get session id
   * @return {observable} - Session details on success or error.
   */
  mentorSessionDetail(id:string, type: string = ''): Observable<any> {
    let params = new HttpParams();
    params = params.append('session_id', id);
    if(type) {
      params = params.append('type', type);
    }
    return this.http.get<any>(this.apiEndpoint + '/mentorship/sessions', { params }).pipe(catchError(this.handleError));
  }

  /**
  * To save session summary
  * @param {object} postData - to save the summary data
  */
  saveSessionSummary(postData: any): Observable<any> {
    return this.http.post(this.apiEndpoint + '/mentorship/summary', postData).pipe(catchError(this.handleError));
  }

  /**
   * To get user pending feedback
   * @return {observable} - Feedback details on success or error.
   */
  pendingFeedback(): Observable<any> {
    return this.http.get<any>(this.apiEndpoint + '/mentorship/pending_feedback', {}).pipe(catchError(this.handleError));
  }

  /**
  * To save feedback summary
  * @param {object} postData - to save the summary data
  */
  saveUserFeedback(postData: any): Observable<any> {
    return this.http.post(this.apiEndpoint + '/mentorship/feedback', postData).pipe(catchError(this.handleError));
  }

  /**
  * To save feedback summary
  * @param {object} postData - to save the confimation data
  */
  confimationSlot(postData: any): Observable<any> {
    return this.http.post(this.apiEndpoint + '/mentorship/slots/confirmation', postData).pipe(catchError(this.handleError));
  }

  /**
  * To save session visibility
  * @param {object} postData - to get post data
  */
  saveSessionVisibility(postData: any): Observable<any> {
    return this.http.post(this.apiEndpoint + '/mentorship/sessions/visibility', postData).pipe(catchError(this.handleError));
  }

  /**
  * To mark action item as done
  * @param {object} postData - to get the post data
  */
  markAsDoneActionItem(postData: any): Observable<any> {
    return this.http.post(this.apiEndpoint + '/mentorship/sessions/action_items', postData).pipe(catchError(this.handleError));
  }

  /**
  * To give feedback to student
  * @param {object} postData - to get the post data
  */
  actionItemFeedback(postData: any): Observable<any> {
    return this.http.post(this.apiEndpoint + '/mentorship/sessions/action_items_feedback', postData).pipe(catchError(this.handleError));
  }
}
